export default __webpack_public_path__ + "static/media/data-analyst-capstone-project.40d2ac01.png";